import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=2934dec0&scoped=true&"
import script from "./YearSelector.vue?vue&type=script&lang=ts&"
export * from "./YearSelector.vue?vue&type=script&lang=ts&"
import style0 from "./YearSelector.vue?vue&type=style&index=0&id=2934dec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2934dec0",
  null
  
)

export default component.exports